import { computed, createModel, signal } from '@preact/signals-react';
import type { WorkspaceService } from 'src/services/WorkspaceService';
import type { LinkEvent, LinkedValue } from 'src/services/WorkspaceService/linking';

export type LinkedOrderSelection = {
    orderId: string;
    instrument?: string;
};

export type AcceptsLinkEvent = (event: LinkEvent) => boolean;

export const LinkingMailboxModel = createModel(
    (init: { workspaceService: Pick<WorkspaceService, 'subscribeLinkEvents'>; acceptsLinkEvent: AcceptsLinkEvent }) => {
        const instrument = signal<LinkedValue<string> | null>(null);
        const accountId = signal<LinkedValue<string> | null>(null);
        const quantity = signal<LinkedValue<number> | null>(null);
        const order = signal<LinkedValue<LinkedOrderSelection> | null>(null);

        const unsubscribe = init.workspaceService.subscribeLinkEvents((event: LinkEvent) => {
            if (!init.acceptsLinkEvent(event)) {
                return;
            }

            switch (event.type) {
                case 'instrument-selected':
                    instrument.value = {
                        value: event.details.instrument,
                        eventId: event.id,
                        from: event.from,
                        channelId: event.channelId,
                    };
                    break;
                case 'account-selected':
                    accountId.value = {
                        value: event.details.accountId,
                        eventId: event.id,
                        from: event.from,
                        channelId: event.channelId,
                    };
                    break;
                case 'quantity-selected':
                    quantity.value = {
                        value: event.details.quantity,
                        eventId: event.id,
                        from: event.from,
                        channelId: event.channelId,
                    };
                    break;
                case 'order-selected':
                    order.value = {
                        value: event.details,
                        eventId: event.id,
                        from: event.from,
                        channelId: event.channelId,
                    };
                    break;
            }
        });

        return {
            instrument: computed(() => instrument.value),
            accountId: computed(() => accountId.value),
            quantity: computed(() => quantity.value),
            order: computed(() => order.value),
            dispose(): void {
                unsubscribe();
            },
        };
    },
);

export type LinkingMailboxModel = InstanceType<typeof LinkingMailboxModel>;
